export const QQ_ANSWERTYPE_SINGLE = 'SINGLE';
export const QQ_ANSWERTYPE_MULTIPLE = 'MULTI';
export const QQ_ANSWERTYPE_FREE_FORM = 'FREE';
